module.exports = __webpack_public_path__ + "static/img/player_05_ph.08dbf17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_05_ph.png
// module id = 1Son
// module chunks = 0